/* Louvion's moving tab indicator, observing the existing filter's public ARIA state.
   Presentation only: no click/filter/search handlers or article-data changes. */
(() => {
  const instances = new Map();
  function initialize(scope = document) {
    scope.querySelectorAll('[data-ratgeber-topics]').forEach(tabs => {
      if (instances.has(tabs)) return;
      let activeTab;
      const update = () => {
        const active = tabs.querySelector('[aria-pressed="true"]');
        if (!active || !tabs.isConnected) return;
        if (activeTab && activeTab !== active) tabs.classList.add('has-selection');
        activeTab = active;
        tabs.style.setProperty('--topic-indicator-width', `${active.offsetWidth}px`);
        tabs.style.setProperty('--topic-indicator-left', `${active.offsetLeft}px`);
        tabs.classList.toggle('is-overflowing', tabs.scrollWidth > tabs.clientWidth + 1);
      };
      const state = new MutationObserver(update);
      state.observe(tabs, { attributes: true, subtree: true, attributeFilter: ['aria-pressed', 'hidden'] });
      const size = new ResizeObserver(update);
      size.observe(tabs);
      tabs.querySelectorAll('[data-topic-filter]').forEach(tab => size.observe(tab));
      instances.set(tabs, () => { state.disconnect(); size.disconnect(); });
      document.fonts.ready.then(update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [tabs, dispose] of instances) {
      if (event.target.contains(tabs)) { dispose(); instances.delete(tabs); }
    }
  });
})();
